<ejs-sidebar #sidebarTreeviewInstance id="sidebar-menu" class="dock-menuc" [width]='swidth' [target]='target'
[mediaQuery]="mediaQuery" [dockSize]='dockSize' [type]='mstype' [enableGestures]="enableGestures" (created)="onCreated($event)">
  <div class="main-menu" [ngClass]="'e-full-height'">
    <ejs-menu [items]='userPermissionService.GetSideNavigationItems.value' #menuObj enablePersistence='true'
      (beforeItemRender)="onBeforeItemRender($event)" (select)="onMenuEj2Select($event)" orientation='Vertical'
      class="e-bigger" id="ejs-menu-left" cssClass='dock-menu'></ejs-menu>
  </div>
</ejs-sidebar>